/**
 * "Thread resolved" message with Undo (OR-1534, Figma "Resolve comments").
 * A compact one-line card: success check, the title, an Undo button and a
 * close X. Stays until closed or Undone, like the app's other floating
 * alerts.
 */
import { CheckCircle, FlipBackward, X } from "@untitledui/icons";
import { Button, ButtonUtility } from "@tricura/atlas-ui";

export function ThreadResolvedToast({ onUndo, onClose, isUndoing }: { onUndo: () => void; onClose: () => void; isUndoing?: boolean }) {
    return (
        <div
            role="status"
            data-autotest="comment-thread-resolved-toast"
            className="bg-primary border-secondary flex items-center gap-3 self-center rounded-xl border py-2 pr-2 pl-3 shadow-lg"
        >
            <CheckCircle aria-hidden="true" className="text-fg-success-primary size-5 shrink-0" />
            <span className="text-secondary flex-1 text-sm font-semibold whitespace-nowrap">Thread resolved</span>
            <Button
                color="secondary"
                size="sm"
                iconLeading={FlipBackward}
                onClick={onUndo}
                isLoading={isUndoing}
                data-autotest="comment-thread-resolved-undo"
            >
                Undo
            </Button>
            <ButtonUtility color="tertiary" size="sm" icon={X} tooltip="Close" onClick={onClose} data-autotest="comment-thread-resolved-close" />
        </div>
    );
}
